import { QuestionnaireComponentKind } from '@main/dynamic-form';

import { QuestionnaireFormFieldConfig } from './form-types';

export function filterFileds<F extends QuestionnaireFormFieldConfig, S extends F>(
  fields: readonly F[],
  fn: (field: F) => field is S,
): S[] {
  return fields.flatMap((field) => {
    if (field.kind === QuestionnaireComponentKind.Section) {
      return field.fields ? filterFileds(field.fields as S[], fn) : [];
    }

    if (fn(field)) {
      return field;
    } else {
      return [];
    }
  });
}
